
import React from "react";

interface JobInputProps {
  value: string;
  onChange: (val: string) => void;
}

export function JobInput({ value, onChange }: JobInputProps) {
  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-slate-700 mb-2">
        Job Description
      </label>
      <div className="relative">
        <textarea
          value={value}
          maxLength={10000}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Paste the job description here or enter a URL..."
          className="w-full min-h-[160px] p-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-slate-900 focus:border-transparent outline-none resize-y text-slate-900 placeholder:text-slate-400 text-sm"
        />
        <div className="absolute bottom-3 right-3 text-xs text-slate-400 pointer-events-none">
           {value.length} chars
        </div>
      </div>
       <p className="mt-2 text-xs text-slate-500">
         Tip: You can also paste a URL to a LinkedIn or Indeed job posting.
       </p>
    </div>
  );
}
